<template>
  <div class="TableSearch">
    <Row>
      <Column v-if="hasSearch" :xs="columns">
        <Field
          icon="search"
          :placeholder="placeholder || this.$t('search')"
          type="text"
          :value="pagination.search"
          @update:value="$emit('update:search', $event)" />
      </Column>
      <Column v-if="hasSort" :xs="columns">
        <Field
          v-if="hasSort"
          :options="sortOptions"
          type="select"
          :value="pagination.sortIndex"
          @update:value="$emit('update:sortIndex', $event)" />
      </Column>
      <!--
      <template v-if="queryCount">
        <Column v-for="(field, key) in pagination.query" :md="12 / queryCount" :key="key">
          <QueryField :field="field"/>
        </Column>
      </template>
      -->
    </Row>
  </div>
</template>

<script>
// import QueryField from './QueryField'

export default {
  props: {
    pagination: Object,
    placeholder: String,
  },
  computed: {
    columns() {
      return this.hasSort && this.hasSearch ? 6 : 12
    },
    hasSearch() {
      return this.pagination.search !== false
    },
    hasSort() {
      return this.pagination.sortOptions.length > 1
    },
    sortOptions() {
      return this.pagination
        .sortOptions
        .map(({ label, labelKey }, index) => [index, label || this.$t(labelKey)])
    },
    // queryCount() {
    //   return Object.keys(this.pagination.query).length + (this.filterExists ? 1 : 0)
    // },
  },
}
</script>

<style lang="scss">
.TableSearch {
  padding: 0;

  .Field-cont {
    margin: 0;
  }

  .Field {
    margin: 0;

    &.withIcon {
      border: 1px solid $border-color;

      > .Icon {
        border-right: none;
        color: $text-color-mid;
      }
    }
  }
}
</style>

<i18n>
{
  "en": {
    "search": "Search",
    "sort": {
      "old": "Oldest",
      "new": "Newest"
    }
  }
}
</i18n>
